import { render } from "./FrontLayout.vue?vue&type=template&id=5319d22d"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import "./FrontLayout.vue?vue&type=style&index=0&id=5319d22d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__